import { connect } from 'react-redux';
import { withAnalytics } from 'analytics';
import { loadStation, stop } from 'actions/player-actions';
import { setUserHDPreference } from 'actions/gigya-actions';
import { getIsLoading, getIsCurrentStationPlaying } from 'store/reducers/player';
import { getUserPrefersHDSources, getIsLoggedIn } from 'store/reducers/user';
import CONTENT_TYPES from 'globalConst/contentTypes-const';
import Card from './Card';

const mapStateToProps = (state, ownProps) => {
  const prefersHD = getUserPrefersHDSources(state);
  const isUserLoggedIn = getIsLoggedIn(state);

  return {
    isLoading: getIsLoading(state),
    isPlaying:
      getIsCurrentStationPlaying(state, {
        station: { slug: ownProps.playStationSlug },
      }) &&
      ((ownProps.preferHD === prefersHD && isUserLoggedIn) || !ownProps.preferHD),
  };
};

const actionWithAnalytics = (action, { source, ...station }) =>
  withAnalytics(action, {
    player_name: CONTENT_TYPES.CARD,
    link_id: CONTENT_TYPES.CARD,
    content_id: source || null,
  })(station);

const mapDispatchToProps = {
  onActionWithAnalytics: actionWithAnalytics,
  onSetPrefersHDSources: setUserHDPreference,
};

const mergeProps = ({ isLoading, isPlaying }, { onActionWithAnalytics, onSetPrefersHDSources }, ownProps) => ({
  ...ownProps,
  isLoading: isLoading && isPlaying,
  isPlaying,
  onStop: () => onActionWithAnalytics(stop, { source: ownProps.collectionTitle || null }),
  onLoad: (station) => {
    if (ownProps.preferHD && station.tritonMountHD) {
      onSetPrefersHDSources(true);
    }
    onActionWithAnalytics(loadStation, {
      ...station,
      source: ownProps.collectionTitle || null,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Card);
